angular.module('tradersyard').controller('User.Settings.General.Ctrl', [
    '$scope',
    '$cookies',
    'graph-user-factory',
    '$flex',
    '$moment',
    '$timeout',
    function ($scope, $cookies, $client, $flex, $moment, $timeout) {
        $scope.node = {};

        angular.extend($scope, $flex.data);

        $scope.gender = {
            male: 'Male',
            female: 'Female',
            other: 'Other',
        };

        $scope.showFriends = {
            all: 'All',
            friends: 'Friends Only',
            nobody: 'Nobody',
        };

        $scope.status = undefined;

        $scope.addStyle = function () {
            $scope.node.trading_styles.push({
                id: 0,
                name: '',
            });
        };

        $scope.removeStyle = function () {
            $scope.node.trading_styles.pop();
        };

        $scope.submit = function (node) {
            var data = angular.copy(node);
            data.datafeeds = [];
            data.trading_styles = [];

            angular.forEach($scope.datafeeds, function (datafeed) {
                if (datafeed.checked) {
                    data.datafeeds.push(datafeed.guid);
                }
            });
            angular.forEach(node.trading_styles, function (style) {
                if (style.name !== '') {
                    data.trading_styles.push(style.name);
                }
            });

            $scope.error = {};

            $client.update('me', data).then(function (response) {
                if (response.data.state === 0) {
                    $scope.status = 'Information was updated';
                } else {
                    $scope.error = response.data.data;
                    $scope.status = undefined;
                }

                $timeout(function () {
                    $scope.status = undefined;
                }, 10000);
            });
        };
    },
]);
